module.exports = __webpack_public_path__ + "static/media/sharpko-large-product.d4495399.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Sharpko/sharpko-large-product.jpg
// module id = 694
// module chunks = 0